import filterUtils from 'app/shared/utils/filterUtils';
import { loadFilterFromUrl } from 'app/shared/flux/actions/FilterActions';
import { getTopMarkets } from 'app/shared/flux/actions/AreaActions';
import { augmentError, formatForLog } from 'app/shared/utils/errors';

const logger = getLogger('pages/MarketTrendsPage');

// @ts-ignore
const serverRouteWillMount = ({ store }) => {
  // fetch top markets and save in redux store
  const { dispatch } = store;
  const state = store.getState();
  const queryObject = state.router.location.query;
  const queryString = state.router.location.search;
  const filterParams = filterUtils.queryStringToGraphQLParams(queryString);
  dispatch(loadFilterFromUrl(queryObject));

  return (
    dispatch(getTopMarkets(filterParams))
      // @ts-ignore
      .catch((err) => {
        augmentError(err, {
          root: 'pages/MarketTrendsPage#serverRouteWillMount',
        });
        console.log(err);

        logger.error(formatForLog(err), 'Market Stats Page: Error fetching Top Markets (SSR)');
      })
  );
};

export default serverRouteWillMount;
